import i18next, { i18n } from "i18next";

export type i18NextJson = Record<string, string>;
export type LanguageSpecifier = "en-us" | "en-uk";
export type ComponentTranslationBundle = Record<LanguageSpecifier, i18NextJson>;

export const DEFAULT_NAMESPACE = "form";

export const ENTITY_TRANSLATION_KEYS = {
	Name: "Name",
	LABELS: {
		Name: "Labels.Name",
		Code: "Labels.Code",
		ExternalKey: "Labels.ExternalKey",
		Classification: "Labels.Classification",
		Timezone: "Labels.Timezone"
	}
};

export type ENTITY_TRANSLATION_KEY = keyof(typeof ENTITY_TRANSLATION_KEYS);

export class I18NextContext {
	public static Instance = new I18NextContext();
	public i18n: i18n;

	constructor() {
	}

	public async init($logger) {
		if(!I18NextContext.Instance.i18n) {
			await i18next.init(
				{
					resources: {},
					debug: true,
					fallbackLng: "en-us",
					lowerCaseLng: true,
					cleanCode: true,
					defaultNS: DEFAULT_NAMESPACE
				}, 
				// eslint-disable-next-line no-console
				(err) => {
					if(err) {
						$logger.error("i18n resources load error", { errors: err });
					} 
					else {
						$logger.debug("i18n resources loaded without errors");
					}
				}
			);

			I18NextContext.Instance.i18n = i18next;

			return I18NextContext.Instance.i18n;
		}
		return Promise.resolve(I18NextContext.Instance.i18n);
	}

	public translateEntityType = (entityCode: string, translationKey: ENTITY_TRANSLATION_KEY, defaultFallback: string, valueCount: string) => {
		const key = `types.${entityCode}.${translationKey}`;
		if(this.i18n.exists(key)) {
			if(valueCount === undefined) {
				return this.i18n.t(key);
			}

			return this.i18n.t(key, { count: parseInt(valueCount, 10) });
		}

		return defaultFallback;
	}

	public translateKey = (translationKey: ENTITY_TRANSLATION_KEY, defaultFallback: string, valueCount: number) => {
		valueCount = valueCount ?? 1;
		const key = `${translationKey}`;
		if(this.i18n.exists(key)) {
			return this.i18n.t(key, { count: valueCount });
		}

		return defaultFallback;
	}
}